import styled from "styled-components";

export const ServiceContainer = styled.div`
  width: 100%;
  padding: 67px 0;
  box-sizing: border-box;
  overflow: hidden;

  @media screen and (max-width: 1024px) {
    width: 100%;
    padding-left: 0px;
  }

  @media screen and (max-width: 768px) {
    width: 768px;
    padding-left: 0px;
  }

  @media screen and (max-width: 430px) {
    width: 100%;
  }

  @media screen and (max-width: 375px) {
    width: 375px;
  }
  @media screen and (max-width: 320px) {
    width: 100%;
  }
`;

export const ServiceDividerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 50px;
  width: 100%;
  @media screen and (max-width: 2560px) {
    width: 100%;
    justify-content: center;
    gap: 230px;
  }

  @media screen and (max-width: 1440px) {
    gap: 30px;
  }

  @media screen and (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  @media screen and (max-width: 430px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 140px;
  }

  @media screen and (max-width: 375px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 140px;
    padding-left: 15px;
  }
`;
